export enum EndpointEnum {
    SIGNUP = '/auth/signup',
    SIGNIN = '/auth/signin',
    REFRESH_TOKEN = '/auth/refresh',
    USERS = '/users/data',
    LOCATIONS = '/locations',
    PHONE = '/phone',
}

export const EndpointsPayment = {
    USER_CREATE: '/users',
    USER_GET: '/users',
    USER_SUBSCRIPTION_GET: '/users/check-subscription',
    PAYMENT_ONE_CLICK_GET: '/users/payment-data',
    SUBSCRIPTION_PLANS_GET: '/subscription-plan',
    SUBSCRIPTION_TRANSACTION_CREATE: '/ixopay/purchase/subscription',
    INAPP_TRANSACTION_CREATE: '/ixopay/purchase/inapp',
    CREATE_PAYPAL_SUBSCRIPTION: '/subscriptions/create',
    USER_SUBSCRIPTION_CANCEL: '/users/subscriptions/cancel',
    USER_SUBSCRIPTION_CONTINUE: '/users/subscriptions/continue',
} as const;
